module.exports = __webpack_public_path__ + "img/logo.2ccaf1b4.png";